import { DatePipe } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { CallService, FormCanDeactivate, PatientService, UserService } from '../../shared';
import { User } from '../../shared/models';

@Component({
	selector: 'app-addpatient',
	templateUrl: './addpatient.component.html',
	styleUrls: ['./addpatient.component.css']
})
export class AddpatientComponent extends FormCanDeactivate {
	pr: NgForm;
	dateform: string;
	i: number;
	i1: number;
	setmask: string;
	setmask1: string;
	maxlen: any;
	maxlen1: any;
	setlength: any;
	setlength1: any;
	bodysurgical: any[];
	payorinfo: any;
	shospital6: boolean;
	shospital7: boolean;
	payortypechange: any = [];
	payortype: any;
	dosstr: any;
	procedurestr: any;
	dos: any = [];
	procedure: any = [];
	fracture: boolean = false;
	globalobj: any;
	maxdate: boolean;
	mindate: boolean;
	showinvaild1: boolean;
	DatepickerConfig: Partial<BsDatepickerConfig>
	@ViewChild('addPatientform')
	form: NgForm;
	userstatus: boolean = true;
	enablepatient: boolean = true;
	modalRef: BsModalRef;
	modalRef1: BsModalRef;
	showloader: boolean = false;
	public deletepa: boolean = false;
	public redir: boolean = false;
	showinvaild: boolean = false;
	public hiddenchecked: boolean = false;
	public showcross: boolean = false;
	medicare: any;
	isArchivedEmail: string = '';
	isArchivedPhone: string = '';

	//define a new patient variable
	public newPatient: any = {
		fName: '',
		lName: '',
		gender: '',
		dob: '',
		code: '+1,USA',
		codeOther: '+1,USA',
		email: '',
		primary:'',
		teleCode: '',
		teleCountryCode: '',
		phone: '',
		otherPhoneType: 1,
		teleCodeOther: '',
		teleCountryCodeOther: '',
		phoneOther: '',
		preferredLanguage: null,
		mrn: '',
		ssn: '',
		height: '',
		weight: '',
		inch: '',
		bmi: '',
		regularSmoker: '',
		diabetic: '',
		bloodPressure: '',
		deletepatient: '',
		commercialPayorType: '',
		plan: '',
		skipcommercial: false,
		tss: '',
		uploadimage: [],
		AddBodyPart: [],
		disqualifi: {}
	};
	public temPatien: any = {};
	laterality: any;
	show: boolean = true
	//default common bodyDetails used push eveerytime when add a bodypart
	public bodyPartDetails: any = {
		dosStatus: 'notSelected',
		bodyLocation: '',
		bodyPart: '',
		bodySide: '',
		surgeonId: '',
		payorType: '',
		mako: '',
		hospitalId: '',
		dischargeWith: '',
		dischargeLoc: '',
		dischargeTo: '',
		cjr: '',
		fracture: ''
	};
	public userRole: User;
	//body parts array
	public bodylocation: any;
	public bodypartlocation: any;
	public listOfParts = [];
	public bodyParts = [];
	public codes = [];
	public alterNo = [];
	public surgeonList = [];
	public snfList = [];
	public hospitalList = [];
	public temArray = [];
	public surgeonUserNames = [];
	public patientUrl = './assets/img/users/addusericon.png'
	public defaultUl = './assets/img/users/addusericon.png'
	public modelMsg = "";
	public dosStatus = 'notSelected';
	public bobMaxDate = new Date();
	public dosMaxDate = new Date(this.bobMaxDate.getTime())
	public imgMaxSize: any = environment.imagefileSize;
	public timealert = environment.timelimit;

	public hospitalid: any;
	public datenew = new Date("01/01/1800");
	public mindatedob = new Date();
	public defaultBodyPart = {
		carePath: '',
		bodyPartStatus: 'False',
		laterality: '',
		hospitalId: '',
		surgeonId: '',
		dos: '',
		mako: '',
		cjr: '',
		fracture: '',
		payorType: '',
		hic: '',
		dischargeDate: '',
		dischargeLoc: '',
		facilityPhone: '',
		facilityContact: '',
		dischargeWith: '',
		dischargeTo: '',
		dischargeId: '',
		dischargeHospitalMasterId: '',
		bpci: ''
	}
	public imagearr = [];
	@ViewChild('myInput')
	myInputVariable: any;
	//upper body options array
	public dateformat: any;
	public bsConfig = Object.assign({});
	public upperBodypartOption = [{
		'value': "Neck-Neck",
		'name': 'Neck'
	}, {
		'value': "Back-Back",
		'name': 'Back'
	}, {
		'value': 'Neck-Back',
		'name': 'Neck & Back'
	}, {
		'value': 'Shoulder-Left',
		'name': 'Shoulder - Left'
	}, {
		'value': 'Shoulder-Right',
		'name': 'Shoulder - Right'
	}, {
		'value': 'Elbow-Left',
		'name': 'Elbow - Left'
	}, {
		'value': 'Elbow-Right',
		'name': 'Elbow - Right'
	}, {
		'value': 'Hand-Left',
		'name': 'Hand - Left'
	}, {
		'value': 'Hand-Right',
		'name': 'Hand - Right'
	},
	{
		'value': 'Wrist-Left',
		'name': 'Wrist - Left'
	}, {
		'value': 'Wrist-Right',
		'name': 'Wrist - Right'
	}, {
		'value': 'Arm-Left',
		'name': 'Arm - Left'
	}, {
		'value': 'Arm-Right',
		'name': 'Arm - Right'
	}, {
		'value': 'Fore Arm-Left',
		'name': 'Fore Arm - Left'
	}, {
		'value': 'Fore Arm-Right',
		'name': 'Fore Arm - Right'
	}
	]
	//lower body Option Array
	public lowerBodypartOption = [{
		'value': "Total Hip Replacement-Left",
		'name': 'Total Hip - Left'
	}, {
		'value': "Total Hip Replacement-Right",
		'name': 'Total Hip - Right'
	}, {
		'value': 'Total Hip Replacement-Bilateral',
		'name': 'Total Hip - Bilateral'
	}, {
		'value': 'Total Knee Replacement-Left',
		'name': 'Total Knee - Left'
	}, {
		'value': 'Total Knee Replacement-Right',
		'name': 'Total Knee - Right'
	}, {
		'value': 'Total Knee Replacement-Bilateral',
		'name': 'Total Knee - Bilateral'
	}, {
		'value': 'Partial Knee Replacement-Left',
		'name': 'Partial Knee - Left'
	}, {
		'value': 'Partial Knee Replacement-Right',
		'name': 'Partial Knee - Right'
	}, {
		'value': 'Partial Knee Replacement-Bilateral',
		'name': 'Partial Knee - Bilateral'
	},
	{
		'value': 'Sports Knee-Left',
		'name': 'Knee Sports - Left'
	}, {
		'value': 'Sports Knee-Right',
		'name': 'Knee Sports - Right'
	}, {
		'value': 'Sports Hip-Left',
		'name': 'Hip Sports - Left'
	}, {
		'value': 'Sports Hip-Right',
		'name': 'Hip Sports - Right'
	}, {
		'value': 'Foot-Left',
		'name': 'Foot - Left'
	}, {
		'value': 'Foot-Right',
		'name': 'Foot - Right'
	}, {
		'value': 'Ankle-Left',
		'name': 'Ankle - Left'
	}, {
		'value': 'Ankle-Right',
		'name': 'Ankle - Right'
	}
	]
	public stageArray: any = [];
	public showTable = false;
	mytodo: any;
	CurrentUser: User;
	public materialsArray: any = [];
	clienttype: string;
	shospital: boolean;
	shospital1: boolean;
	shospital2: boolean;
	shospital3: boolean;
	shosp: boolean;
	shospital5: boolean;
	bodyparttype: boolean;
	sidepart: any;
	surgeonname: any;
	plan = '';
	partbody: any;
	tabID: any;
	preferredLang = {
		"multiLanguageRequired": false,
		"languages": "en,es"
	}
	constructor(private userService: UserService,
		private patientService: PatientService,
		private datepipe: DatePipe, private toast: ToastrService, private callService: CallService,
		private router: Router, private modalService: BsModalService, private localeService: BsLocaleService) {
		super();
		enGbLocale.invalidDate = '';
		enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
		enGbLocale.week.dow = 0;
		defineLocale('custom locale', enGbLocale);
		this.localeService.use('custom locale');

		//console.log("Patid", window.localStorage['patid']  )
		if (window.localStorage['patid']) {
			window.localStorage.removeItem('patid')
		}

		//console.log("patientId", window.localStorage['patientId']  )
		if (window.localStorage['patientId']) {
			window.localStorage.removeItem('patientId')
		}

	}

	ngOnInit() {
		this.dosMaxDate.setDate(this.dosMaxDate.getUTCDate() + 365);
		this.userService.currentUser.subscribe(
			(userData) => {
				this.CurrentUser = userData;
				this.CurrentUser.status = false;
				if (this.CurrentUser.item) {
					this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0');
					this.setmask1 = this.CurrentUser.item.phoneFormat.split('#').join('0');
					if (this.CurrentUser.item.language != 'en_uk') {
						this.newPatient.code = '+1,USA'
						this.newPatient.codeOther = '+1,USA'
					} else if (this.CurrentUser.item.language == 'en_uk') {
						this.newPatient.code = '+44,UK'
						this.newPatient.codeOther = '+44,UK'
					}
					if (this.CurrentUser.item.clientTeleCode) {
						this.newPatient.code = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
						this.newPatient.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
					}
					this.checkphonelength(this.newPatient.code)
					this.checkphonelength1(this.newPatient.codeOther)
					if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
						this.dateformat = environment.dateFormat;
						this.dateform = environment.dateForm;
					} else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
						this.dateformat = 'DD/MM/YYYY'
						this.dateform = 'dd/MM/yyyy';
					}
					this.newPatient.otherPhoneType = 1
					this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
				}
				//this.hospitalid = 100317;
			}
		)
		this.hospitalid = this.CurrentUser.item.userAccountKey;
		this.clienttype = this.CurrentUser.item.clientType;
		// this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0');
		////console.log("type", this.clienttype)
		this.getClientLanguageConfig();
		this.getpayortypelist()
		this.getBodyPart();
		this.getSurgeonNames();
		this.getHospitalLsit();
		this.getselect();
		this.getalter();
		this.getSnfNames();
		this.getfacilitylist();

		let pusdata = Object.assign({}, this.bodyPartDetails)
		this.listOfParts.length = 0;
		this.listOfParts.push(pusdata)
	}
	//getbundletype
	getbundlepayortype(id) {
		let self = this;
		self.patientService.getBundlepartType(this.CurrentUser.item.userAccountKey, id)
			.subscribe(data => {
				this.bodysurgical = []
				this.listOfParts[0].dos = ''
				this.listOfParts[0].hospitalId = ''
				this.listOfParts[0].surgeonId = ''
				this.listOfParts[0].bodyLocation = '';
				this.listOfParts[0].bodyPart = ''
				this.listOfParts[0].bodySide = ''
				this.payortypechange = data
				////console.log(this.payortypechange)
				this.patientService.getSurgicalLocation(this.CurrentUser.item.userAccountKey, id).subscribe(data => {
					this.bodysurgical = data
				})
				if (id)
					this.patientService.getHospitalListbyPayor(id, this.CurrentUser.item.userAccountKey, 0).subscribe(data => {
						self.hospitalList = _.filter(data, (o) => {
							return o.hospitalId != 500000
						})
					})
				//////console.log(this.bodylocation.ServicelineLabel)
			})
	}
	// get body parts
	getBodyPart() {
		let self = this;
		self.patientService.getBodyLocation(this.CurrentUser.item.userAccountKey)
			.subscribe(data => {
				self.bodylocation = data
				//////console.log(this.bodylocation.Location)
				//////console.log(this.bodylocation.ServicelineLabel)
			})
		/* self.patientService.getBodypartLocation(this.CurrentUser.item.userAccountKey)
		.subscribe(data => {
			self.bodypartlocation = data
			//////console.log(this.bodylocation.Location)
			//////console.log(this.bodylocation.ServicelineLabel)
		}) */
	}
	public payortypelist: any;
	getpayortypelist() {
		this.patientService.getPayorTypeList(this.CurrentUser.item.userAccountKey)
			.subscribe(data => {
				this.payortypelist = data
			})
	}

	getClientLanguageConfig() {
		this.patientService.getClientLanguageConfig(this.CurrentUser.item.userAccountKey)
			.subscribe(data => {
				if(data && data.hasOwnProperty("multiLanguageRequired")) {
					this.preferredLang = data;
					this.newPatient.preferredLanguage = this.userService.cnDefaultLang;
				}
			})
	}
	getToday(): string {
		return new Date().toISOString().split('T')[0]
	}
	getselect() {
		let self = this;
		self.patientService.getselcode(this.hospitalid)
			.subscribe(data => {
				self.codes = data

			})
	}
	getalter() {
		let self = this;
		self.patientService.getAlterNo()
			.subscribe(data => {
				self.alterNo = data
				self.newPatient.otherPhoneType = 1
			})
	}
	//get Loogged user Deatils
	getLoggedUserDetails() {
		let self = this;
		self.userService.currentUser
			.subscribe(
				data => {
					self.userRole = data
				}
			)

	}

	userId: string;
	selecthosp: any = [];
	//get surgeon names for the drop down surgeon
	getSurgeonNames() {
		let self = this;

		/* ////console.log("UseFilter",this.patientService.userFilter)

		this.userId = this.patientService.userFilter ?
					self.CurrentUser.item.userAccountId: this.patientService.userId; */

		self.patientService.getSurgeonlist(self.CurrentUser.item.userAccountId)
			.subscribe(data => {
				self.surgeonList = data;
				////console.log("Surgeon List", self.surgeonList)
			})
	}
	//get options for snf names
	getSnfNames() {
		let self = this;
		self.patientService.getSnfList()
			.subscribe(data => {
				self.snfList = data.aaData[0].dischargehospitalList
			})
	}

	//get options for facilityList names
	facilityList: any;
	getfacilitylist() {
		let self = this;
		self.patientService.getFacilityList(this.hospitalid)
			.subscribe(data => {
				self.facilityList = data
			})
	}
	findPastorFutureDate(dos, argDate) {
		argDate = new Date(argDate);
		dos = new Date(dos);
		////console.log('argDate'+argDate)
		////console.log('dos'+dos)
		if (argDate < dos)
			return true;

		return false;
	}
	changeFormatToDate(dateString) {
		var changedFormat;
		if (this.CurrentUser.item.language == 'en_uk' && (typeof dateString == 'string' || dateString instanceof String)) {
			var splitDate1 = dateString.split('/');
			if (splitDate1.length > 1) {
				var day1 = splitDate1[0];
				var month1 = splitDate1[1];
				var year1 = splitDate1[2];
				changedFormat = month1 + "/" + day1 + "/" + year1;
				return changedFormat
			} else {
				var date: any = dateString
				return new Date(date)
			}
		} else {
			return new Date(dateString)
		}
	}
	//check the dos and changes it's status
	dateofdob: boolean = false
	onDateValueChange(event, form) {
		////console.log(this.newPatient.dob)
		let self = this;
		let date = this.datepipe.transform(event, 'yyyy-MM-dd');
		if (date) {
			if (!self.newPatient.dob) {
				self.toast.error(this.userService.translateText('hospital_portal.disp_messages.select_dob.error'), '', {
					timeOut: this.timealert
				})
				return;
			}
			let toDate = new Date();
			toDate.setDate(toDate.getDate() - 1);
			let Dos = new Date(date);
			let bDos = new Date(date);
			bDos.setDate(bDos.getDate() + 1)
			var dobDiff = this.findPastorFutureDate(this.changeFormatToDate(self.newPatient.dob), this.changeFormatToDate(event));
			if (dobDiff) {
				this.dateofdob = true
				this.listOfParts[0].dos = null;
				return;
			}
			else {
				this.dateofdob = false
			}
			// else if (dob > bDos.getTime() && this.CurrentUser.item.commercialType && this.listOfParts[0].payorType == '1') {
			// 	self.toast.error('Date of Surgery should not be Past ', '', {
			// 		timeOut: this.timealert
			// 	});
			// 	return;
			// }
			if (toDate.getTime() <= Dos.getTime()) {
				if (form == 'main') {
					self.dosStatus = "future"
				}
				if (form != 'main') {
					self.listOfParts[form]['dosStatus'] = "future"
				}
			}

			if (toDate.getTime() > Dos.getTime()) {
				if (form == 'main') {
					self.dosStatus = "past"
				}
				if (form != 'main') {
					self.listOfParts[form]['dosStatus'] = "past"
				}
			}
		} else {
			if (form != 'main') {
				self.listOfParts[form]['dosStatus'] = "notSelected"
			}
		}
	}
	//calculate the bmi
	calculateBmi() {
		let self = this;
		if (self.newPatient.weight && self.newPatient.height && self.newPatient.inch) {
			self.calculateBMI(self.newPatient.weight, self.newPatient.height, self.newPatient.inch)
		} else {
			self.newPatient.bmi = null;
		}
	}
	//calculate bmi
	calculateBMI(weight, height, inch) {
		let self = this;
		weight = parseFloat(weight);
		height = parseInt(height);
		inch = parseInt(inch);

		weight = weight * 0.453592;
		height = (((height * 12) + inch) * .0254);
		let bmi = weight / Math.pow(height, 2.0);
		self.newPatient.bmi = bmi.toFixed(2)
	}

	//add a new  body part
	addBodyPart(data) {

		let self = this;
		//let index = self.listOfParts.length;
		if (self.listOfParts.length < 3) {
			let pushdata = Object.assign({}, self.bodyPartDetails)
			self.listOfParts.push(pushdata)
			//  if(!self.listOfParts.length){
			//   data.dosStatus =self.dosStatus;
			//   data.bodyParts = self.bodyParts;
			//   data.surgeonUserNames = self.surgeonUserNames;
			//   let pushData1 = Object.assign({},data)
			//   let pushData2 = Object.assign({},data)
			//   self.listOfParts.push(pushData1)
			//    self.listOfParts.push(pushData2)
			//  }else{
			//   let pushData = Object.assign({},data)
			//   self.listOfParts.push(pushData)
			//  }
		} else {
			//  self.toast.error(`Can't add more than three body part`);
		}

		//  self.listOfParts[index]=pushData;
	}

	//remove the body part form the list
	/**
	 *
	 * @param data form
	 * @param index index of array
	 */
	removeBodyPart(data: NgForm, index) {
		let self = this;
		let length = self.listOfParts.length;
		for (let i = index; i < length - 1; i++) {
			self.listOfParts[i] = Object.assign({}, self.listOfParts[i + 1]);
		}
		self.listOfParts.splice(length - 1, 1)
		//let l2 = self.listOfParts.length
		//self.getBodyParts(self.listOfParts[l2-1].bodyLocation,l2-1);
	}

	changeBodyLocation() {

	}


	//get hispital list for drop down
	getHospitalLsit() {
		let self = this;
		self.patientService.getHospitalList(self.CurrentUser.item.userAccountId)
			.subscribe(data => {
				self.hospitalList = _.filter(data.aaData, (o) => {
					return o.hospitalId != 10001
				})
			})
	}
	//clear the mrn number by click
	/**
	 *
	 * @param event check box event
	 */
	setMRNnull(event) {
		let self = this;
		if (self.newPatient.mrn) {
			self.newPatient.mrn = '';
		}
	}
	//clear the ssn number in click
	/**
	 *
	 * @param event check box event
	 */
	setssnnull(event) {
		let self = this;
		if (self.newPatient.ssn) {
			self.newPatient.ssn = ''
		}
	}
	//get body part option based on the body location
	/**
	 *
	 * @param event body location value
	 * @param form index of array
	 */
	getBodyParts(bodypart, event, index) {
		////console.log("bodypart", bodypart)
		this.partbody = bodypart;
		if (bodypart == "Upper Extremity") {
			this.bodyparttype = true;
		} else {
			this.bodyparttype = false;
		}
		//////console.log(self.upperBodypartOption)
		/*
		self.bodyParts  = [];
		if(event == 'upper'){
			if(form == 'main'){
			 self.bodyParts = self.upperBodypartOption;
			}
			if(form != 'main'){
				if(self.listOfParts.length == 1){
				 self.listOfParts[0].upperbodyParts = self.upperBodypartOption;
				 return;
				}
				if(self.listOfParts.length == 2){
					if(self.listOfParts[1].bodyPart == 'Neck-Back'){
					 self.listOfParts[0].upperbodyParts = self.filterNeckAndBack(self.upperBodypartOption,'Neck-Neck','Back-Back',self.listOfParts[1].bodyPart)
					}else if(self.listOfParts[1].bodyPart == 'Neck-Neck' || self.listOfParts[1].bodyPart == 'Back-Back' ){
					 self.listOfParts[0].upperbodyParts = self.filterNeckAndBack(self.upperBodypartOption,'Neck-Back',self.listOfParts[1].bodyPart)
					}else{
					 self.listOfParts[0].upperbodyParts  = _.reject(self.upperBodypartOption,['value',self.listOfParts[1].bodyPart]);
					}
					if(self.listOfParts[0].bodyPart == 'Neck-Back'){
					 self.listOfParts[1].upperbodyParts  = self.filterNeckAndBack(self.upperBodypartOption,'Neck-Neck','Back-Back',self.listOfParts[1].bodyPart)
				 }else if(self.listOfParts[0].bodyPart == 'Neck-Neck' || self.listOfParts[0].bodyPart == 'Back-Back' ){
					 self.listOfParts[1].upperbodyParts  = self.filterNeckAndBack(self.upperBodypartOption,'Neck-Back',self.listOfParts[1].bodyPart)
				 }else{
					 self.listOfParts[1].upperbodyParts  = _.reject(self.upperBodypartOption,['value',self.listOfParts[0].bodyPart]);
				 }
					return;
				}
				if(self.listOfParts.length == 3){
				 let lsit0 = [];
				 let lsit1 = []
				 let lsit2 = [];
				 if(self.listOfParts[1].bodyPart == 'Neck-Back'){
					 lsit0=self.filterNeckAndBack(self.upperBodypartOption,'Neck-Neck','Back-Back',self.listOfParts[1].bodyPart);
					}else if(self.listOfParts[1].bodyPart == 'Neck-Neck' || self.listOfParts[1].bodyPart == 'Back-Back' ){
					 lsit0=self.filterNeckAndBack(self.upperBodypartOption,'Neck-Back',self.listOfParts[1].bodyPart);
					}else{
					 lsit0 =_.reject(self.upperBodypartOption,['value',self.listOfParts[1].bodyPart])
					}
					if(self.listOfParts[0].bodyPart == 'Neck-Back'){
					 lsit1=self.filterNeckAndBack(self.upperBodypartOption,'Neck-Neck','Back-Back',self.listOfParts[0].bodyPart);
					 lsit2=self.filterNeckAndBack(self.upperBodypartOption,'Neck-Neck','Back-Back',self.listOfParts[0].bodyPart);
				 }else if(self.listOfParts[0].bodyPart == 'Neck-Neck' || self.listOfParts[0].bodyPart == 'Back-Back' ){
					 lsit1=self.filterNeckAndBack(self.upperBodypartOption,'Neck-Back',self.listOfParts[0].bodyPart);
					 lsit2=self.filterNeckAndBack(self.upperBodypartOption,'Neck-Back',self.listOfParts[0].bodyPart);
					}else{
					 lsit1 =_.reject(self.upperBodypartOption,['value',self.listOfParts[0].bodyPart])
					 lsit2 =_.reject(self.upperBodypartOption,['value',self.listOfParts[0].bodyPart])
					}

					if(self.listOfParts[2].bodyPart == 'Neck-Back'){
					 self.listOfParts[0].upperbodyParts=self.filterNeckAndBack(lsit0,'Neck-Neck','Back-Back',self.listOfParts[2].bodyPart);
					 self.listOfParts[1].upperbodyParts=self.filterNeckAndBack(lsit1,'Neck-Neck','Back-Back',self.listOfParts[2].bodyPart);
				 }else if(self.listOfParts[2].bodyPart == 'Neck-Neck' || self.listOfParts[2].bodyPart == 'Back-Back' ){
					 self.listOfParts[0].upperbodyParts=self.filterNeckAndBack(lsit0,'Neck-Back',self.listOfParts[2].bodyPart);
					 self.listOfParts[1].upperbodyParts=self.filterNeckAndBack(lsit1,'Neck-Back',self.listOfParts[2].bodyPart);
					}else{
					 self.listOfParts[0].upperbodyParts = _.reject(lsit0,['value',self.listOfParts[2].bodyPart]);
					 self.listOfParts[1].upperbodyParts = _.reject(lsit1,['value',self.listOfParts[2].bodyPart]);
					}
					if(self.listOfParts[1].bodyPart == 'Neck-Back'){
					 self.listOfParts[2].upperbodyParts=self.filterNeckAndBack(lsit2,'Neck-Neck','Back-Back',self.listOfParts[1].bodyPart);
					}else if(self.listOfParts[1].bodyPart == 'Neck-Neck' || self.listOfParts[1].bodyPart == 'Back-Back' ){
					 self.listOfParts[2].upperbodyParts=self.filterNeckAndBack(lsit2,'Neck-Back',self.listOfParts[1].bodyPart);
					}else{
					 self.listOfParts[2].upperbodyParts = _.reject(lsit2,['value',self.listOfParts[1].bodyPart]);
					}
				}
			}
		}

		if(event == 'lower'){
		 if(form == 'main'){
			 self.bodyParts = self.lowerBodypartOption;
			}
			if(form != 'main'){
			 if(self.listOfParts.length == 1){
				 self.listOfParts[form].lowerbodyParts = self.lowerBodypartOption;
				 return;
				}
				if(self.listOfParts.length == 2){
				 if(self.listOfParts[1].bodyPart.includes('Knee') || self.listOfParts[1].bodyPart.includes('Hip')){
					 self.listOfParts[0].lowerbodyParts  = self.filterBilater(self.lowerBodypartOption,self.listOfParts[1].bodyPart)
				 }else{
					 self.listOfParts[0].lowerbodyParts  = _.reject(self.lowerBodypartOption,['value',self.listOfParts[1].bodyPart]);
				 }
					if(self.listOfParts[0].bodyPart.includes('Knee') || self.listOfParts[0].bodyPart.includes('Hip')){
					 self.listOfParts[1].lowerbodyParts  = self.filterBilater(self.lowerBodypartOption,self.listOfParts[0].bodyPart);
				 }else{
					 self.listOfParts[1].lowerbodyParts  = _.reject(self.lowerBodypartOption,['value',self.listOfParts[0].bodyPart]);
				 }
				 return
				}
				if(self.listOfParts.length == 3){
					let lsit0 = [];
					let lsit1 = []
					let lsit2 = [];
				 if(self.listOfParts[1].bodyPart.includes('Knee') || self.listOfParts[1].bodyPart.includes('Hip')){
						lsit0=self.filterBilater(self.lowerBodypartOption,self.listOfParts[1].bodyPart)
				 }else{
						lsit0=_.reject(self.lowerBodypartOption,['value',self.listOfParts[1].bodyPart]);
				 }
				 if(self.listOfParts[0].bodyPart.includes('Knee') || self.listOfParts[0].bodyPart.includes('Hip')){
						lsit1 =self.filterBilater(self.lowerBodypartOption,self.listOfParts[0].bodyPart)
						lsit2 =self.filterBilater(self.lowerBodypartOption,self.listOfParts[0].bodyPart)
				 }else{
						lsit1 =_.reject(self.lowerBodypartOption,['value',self.listOfParts[0].bodyPart])
						lsit2 =_.reject(self.lowerBodypartOption,['value',self.listOfParts[0].bodyPart])
				 }
				 if(self.listOfParts[2].bodyPart.includes('Knee') || self.listOfParts[2].bodyPart.includes('Hip')){
					 self.listOfParts[0].lowerbodyParts = self.filterBilater(lsit0,self.listOfParts[2].bodyPart)
					 self.listOfParts[1].lowerbodyParts =self.filterBilater(lsit1,self.listOfParts[2].bodyPart)
				 }else{
					 self.listOfParts[0].lowerbodyParts = _.reject(lsit0,['value',self.listOfParts[2].bodyPart]);
					 self.listOfParts[1].lowerbodyParts = _.reject(lsit1,['value',self.listOfParts[2].bodyPart]);
				 }
				 if(self.listOfParts[1].bodyPart.includes('Knee') || self.listOfParts[1].bodyPart.includes('Hip')){
					 self.listOfParts[2].lowerbodyParts = self.filterBilater(lsit2,self.listOfParts[1].bodyPart)
				 }else{
					 self.listOfParts[2].lowerbodyParts = _.reject(lsit2,['value',self.listOfParts[1].bodyPart]);
				 }



				 //  self.listOfParts[0].bodyParts = _.reject(_.reject(self.lowerBodypartOption,['value',self.listOfParts[1].bodyPart]),self.listOfParts[2].bodyPart);
				 //  self.listOfParts[1].bodyParts = _.reject(_.reject(self.lowerBodypartOption,['value',self.listOfParts[0].bodyPart]),self.listOfParts[2].bodyPart);
				 //  self.listOfParts[2].bodyParts = _.reject(_.reject(self.lowerBodypartOption,['value',self.listOfParts[0].bodyPart]),self.listOfParts[1].bodyPart);
				}
			}
		} */

	}
	checkservice(bodypart, event, index) {
		this.listOfParts[index].bodySide = ''
		this.listOfParts[index].other = ''
		if (event == 'Total Shoulder Replacement') {
			this.laterality = ['Left', 'Right']

		}
		if (event) {
			let i = _.findIndex(this.bodylocation.ServicelineLabel, (o: any): any => {
				return (o.ServicelineLabel == event) && (o.SurgicalLocationDisplayName == this.listOfParts[index].bodyLocation)
			})
			if (i != -1) {
				this.listOfParts[index].bodyprocedure = this.bodylocation.ServicelineLabel[i].Location
			}
			else {
				this.listOfParts[index].bodyprocedure = 'Other'
			}

			bodypart = this.listOfParts[index].bodyprocedure
		}
		////console.log(event, this.sidepart, this.surgeonname)
		let self = this;
		if (event == 'Lumbar Fusion' || event == 'Lumbar Laminectomy' || event == 'Cervical Fusion' || event == 'Cervical Laminectomy' || event == 'T-Spine' || (event == 'Other.' && (this.listOfParts[index].bodyLocation == 'Back' || this.listOfParts[index].bodyLocation == 'Neck'))) {
			//let sArray = event.split('-')
			// self.getBodyParts(bodyLocation,index)
			this.partbody = bodypart
			this.show = false;
			if (event && this.partbody && this.surgeonname)
				self.patientService.getBodyPartServiceAvailable(event, this.partbody, this.surgeonname)
					.subscribe(data => {
						if (data.surveyStatus == 'false') {
							//self.listOfParts[index].bodyPart=""
							self.listOfParts[index].bodySide = ""
							self.toast.error(this.userService.translateText('hospital_portal.disp_messages.selected_service.error'), '', {
								timeOut: this.timealert
							})
						}
						if (data.surveyStatus == 'true') {
							self.listOfParts[index].workflowId = data.viewWorkflowId;
						}
						//  if()
					})

		} else if (event == 'Sports Knee') {
			this.laterality = ['Left', 'Right']
		} else {
			this.show = true

			if (event && this.sidepart && this.surgeonname)
				self.patientService.getBodyPartServiceAvailable(event, this.sidepart, this.surgeonname)
					.subscribe(data => {
						if (data.surveyStatus == 'false') {
							self.listOfParts[index].bodyPart = ""
							self.toast.error(this.userService.translateText('hospital_portal.disp_messages.selected_service.error'), '', {
								timeOut: this.timealert
							})
						}
						if (data.surveyStatus == 'true') {
							self.listOfParts[index].workflowId = data.viewWorkflowId;
						}


					})
		}
		if (this.listOfParts[index].bodyprocedure != 'Hip') {
			this.fracture = false
		}
		if (environment.OpBodyPart.search(event) == -1) {
			this.hospitalList = _.filter(this.hospitalList, (o: any): any => {
				return o.admissionId != 2
			})
			//console.log(JSON.stringify(this.hospitalList))
		} else if (!this.CurrentUser.item.commercialType || (this.CurrentUser.item.userrole != 'Commercial Care Navigator' && this.CurrentUser.item.userGroupId != 34)) {
			this.hospitalList = [];
			this.getHospitalLsit();
		} else {
			let surgeonId = this.listOfParts[index].surgeonId ? this.listOfParts[index].surgeonId : 0
			this.getHospitalalListByPayor(surgeonId)
		}


	}
	//show side
	showlist(proceduretype) {
		if (this.listOfParts[0].payorType == '1' && this.CurrentUser.item.commercialType) {
			switch (proceduretype) {
				case "Total Shoulder Replacement":
					return this.laterality = ['Left', 'Right']
				case 'T-Spine':
					return this.laterality = []
				case "Lumbar Fusion":
					return this.laterality = []
				case "Lumbar Laminectomy":
					return this.laterality = []
				case "Cervical Fusion":
					return this.laterality = []
				case "Cervical Laminectomy":
					return this.laterality = []
				case "T-Spine":
					return this.laterality = []
				default:
					return this.laterality = ['Left', 'Right']
			}
		} else {
			switch (proceduretype) {
				case "Total Shoulder Replacement":
					return this.laterality = ['Left', 'Right']
				case 'T-Spine':
					return this.laterality = []
				case "Lumbar Fusion":
					return this.laterality = []
				case "Lumbar Laminectomy":
					return this.laterality = []
				case "Cervical Fusion":
					return this.laterality = []
				case "Cervical Laminectomy":
					return this.laterality = []
				case "T-Spine":
					return this.laterality = []
				default:
					return this.laterality = ['Left', 'Right', 'Bilateral']
			}
		}

	}
	//filter bodyparts option array
	/**
	 *
	 * @param dataArray bodyPart option array
	 * @param value filter value
	 */
	filterBilater(dataArray, value) {
		if (value.includes('Bilateral')) {
			let array = value.split('-')
			return _.reject(dataArray, function (o) {
				return o.value.includes(array[0])
			})
		} else {
			let temArray = [];
			temArray.push(value);
			let sarray = value.split('-');
			sarray[1] = 'Bilateral';
			temArray.push(sarray.join('-'))
			return _.reject(dataArray, function (o) {
				return temArray.includes(o.value)
			})
		}
	}
	//filter the upper body option neck and back
	/**
	 *
	 * @param dataArray upper body option array
	 * @param arg filter value user spred operator to get array
	 */
	filterNeckAndBack(dataArray, ...arg) {
		return _.reject(dataArray, o => {
			return arg.includes(o.value)
		})
	}



	getHospitalalListByPayor(surgeonId) {
		if (this.newPatient.commercialPayorType)
			this.patientService.getHospitalListbyPayor(this.newPatient.commercialPayorType, this.CurrentUser.item.userAccountKey, surgeonId).subscribe(data => {
				this.hospitalList = _.filter(data, (o) => {
					return o.hospitalId != 500000
				})
			})
	}
	//filter option for drop down discharge event
	/**
	 *
	 * @param event select surgeon id
	 * @param form index
	 */
	formSurgeonIdChange(bodypart, side, event, form) {
		let self = this;
		let temArray, temArray1 = []
		self.listOfParts[0].hospitalId = ""
		temArray = _.filter(self.surgeonList, (n) => {
			return n.surgeonId == event
		})
		if (this.CurrentUser.item.commercialType && this.newPatient.commercialPayorType) {
			let surgeonId = event ? event : 0
			this.getHospitalalListByPayor(surgeonId)
		}
		if (this.hospitalList) {
			temArray1 = _.filter(this.hospitalList, (n) => {
				return (n.name.match('Unknown') || n.name.match('Other'))
			})
			temArray1 = temArray1.map(function (el) { return el.hospitalId; });
		}
		self.selecthosp = JSON.parse(temArray[0].hospitalList)
		if (temArray1.length > 0 && self.selecthosp.length > 0) {
			self.selecthosp = self.selecthosp.concat(temArray1)
		}

		if (form == 'main') {
			self.surgeonUserNames = temArray;

		}
		if (form != 'main') {
			self.listOfParts[form].surgeonUserNames = temArray;

		}
		self.checkServiceAvailablity(bodypart, side, event, form)
	}

	formPayorTypeChange(selection2, payorType) {
		let self = this;
		////console.log("med", payorType)
		self.medicare = payorType;
		this.bodysurgical = []
		this.listOfParts[0].dos = ''
		this.listOfParts[0].hic = ''
		this.listOfParts[0].hospitalId = ''
		this.listOfParts[0].bodyLocation = '';
		this.listOfParts[0].bodyPart = ''
		this.listOfParts[0].bodySide = ''
		if (payorType == '1' && this.CurrentUser.item.commercialType) {
			this.mindatedob = new Date();
			this.listOfParts[0].dos = ''
			this.listOfParts[0].hospitalId = ''
			this.listOfParts[0].bodyLocation = '';
			this.listOfParts[0].bodyPart = ''
			this.listOfParts[0].bodySide = ''
			this.shospital = false
			this.showinvaild = false
			this.patientService.getbundletype().subscribe(data => {
				this.payortype = data
			})
			if (this.newPatient.email) {
				this.patientService.getBundlePatientPayorInfo(this.newPatient.email).subscribe(data => {
					if (data.status) {
						this.payorinfo = data
						this.modalRef1 = this.modalService.show(selection2, {
							class: 'modal-sm',
							backdrop: 'static'
						})
						this.movable()
					}

				})
			}
		} else {
			if (this.newPatient.dob)
				this.mindatedob = new Date(this.newPatient.dob);
			else
				this.mindatedob = new Date()
			this.newPatient.plan = ''
			this.newPatient.tss = ''
			this.newPatient.commercialPayorType = ''
			this.newPatient.skipcommercial = false
			this.patientService.getSurgicalLocation(this.CurrentUser.item.userAccountKey, 0).subscribe(data => {
				this.bodysurgical = data
			})
			this.getHospitalLsit()
		}
	}

	getSurgicalLocation(event) {
		if (event) {
			this.newPatient.plan = ''
			this.newPatient.tss = ''
			this.newPatient.commercialPayorType = ''
			this.listOfParts[0].dos = ''
			this.listOfParts[0].hospitalId = ''
			this.listOfParts[0].bodyLocation = '';
			this.listOfParts[0].bodyPart = ''
			this.listOfParts[0].bodySide = ''
			this.newPatient.commercialPayorType = ""
			this.patientService.getSurgicalLocation(this.CurrentUser.item.userAccountKey, 0).subscribe(data => {
				this.bodysurgical = data
			})
			//this.getHospitalLsit()

		}

	}

	//validate the email address using regex pattern
	/**
	 *
	 * @param email patient email
	 *
	 */
	validateEmail(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}
	//check email is already taken

	patientinfo: any;
	checkEmail(patientdetails, f) {
		let self = this;
		if (!self.newPatient.email) {
			return;
		}
		let checkEmail = self.validateEmail(self.newPatient.email)
		if (checkEmail) {
			let email = {
				"email": self.newPatient.email,
				"hospitalId": this.CurrentUser.item.userAccountKey
			}
			self.patientService.checkPatienExists(email)
				.subscribe(data => {
					////console.log(this.timealert)
					// if (data) {
					// 	self.newPatient.email = ""
					// 	self.toast.error("This email has already been registered", '', {
					// 		timeOut: this.timealert


					// 	})
					// }
					// else {
					this.isArchivedEmail = data?.validate_pt;
					if(data?.validate_pt == 'ADD_PATIENT_ERROR') {
						self.newPatient.email = ""
						self.toast.error(this.userService.translateText('patient_portal.display_messages.something_went_wrong'), '', {
							timeOut: this.timealert
						})
					}
					else if(data?.validate_pt != 'NEW_PATIENT') {
						this.getPatientDetails(email, patientdetails, f)
					}
					//}
				})
		} else {
			self.newPatient.email = ""
			self.toast.error(this.userService.translateText('hospital_portal.disp_messages.enter_valid_email.error'), '', {
				timeOut: this.timealert
			})

		}
	}
	//check phone number is already exists
	checkPhone(patientdetails, f) {
		let self = this;
		if (self.newPatient.phone) {
			let code = self.newPatient.code.split(',')
			let codeOther = self.newPatient.codeOther.split(',')
			if (code[0] + self.newPatient.phone == codeOther[0] + self.newPatient.phoneOther && self.newPatient.phoneOther) {
				this.toast.error(this.userService.translateText('hospital_portal.disp_messages.mob_no_should_not_same.error'), '', {
					timeOut: this.timealert
				})
				return self.newPatient.phone = ''
			} else {
				let telecode = self.newPatient.code.split(',')
				let phone1 = {
					"phone": self.newPatient.phone,
					"teleCode": telecode[0],
					"hospitalId": this.CurrentUser.item.userAccountKey
				}
				//if (!this.getPatientDetails(phone1, patientdetails)) {
				self.patientService.checkPatienExists(phone1)
					.subscribe(data4 => {
						//if (data4) {
						// 	self.toast.error("Mobile number already Exists", '', {
						// 		timeOut: this.timealert
						// 	})
						// 	if (this.CurrentUser.item.clientTeleCode)
						// 		self.newPatient.code = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
						// 	else {
						// 		if (this.CurrentUser.item.language != 'en_uk') {
						// 			this.newPatient.code = '+1,USA'
						// 		} else if (this.CurrentUser.item.language == 'en_uk') {
						// 			this.newPatient.code = '+44,UK'
						// 		}
						// 	}
						// 	self.newPatient.phone = "";
						// 	this.checkphonelength(self.newPatient.code)
						// }
						// else {
						this.isArchivedPhone = data4?.validate_pt;
						if(data4?.validate_pt == 'ADD_PATIENT_ERROR') {
							self.newPatient.email = ""
							self.toast.error(this.userService.translateText('patient_portal.display_messages.something_went_wrong'), '', {
								timeOut: this.timealert
							})
						}
						else if(data4?.validate_pt != 'NEW_PATIENT') {
							this.getPatientDetails(phone1, patientdetails, f)
						}
						// }
					})
			}
			//}
		}
	}

	//check alternate phone number is already exists
	checkPhone1() {
		let self = this;
		if (self.newPatient.phoneOther) {
			let code = self.newPatient.code.split(',')
			let codeOther = self.newPatient.codeOther.split(',')
			if (code[0] + self.newPatient.phone == codeOther[0] + self.newPatient.phoneOther && self.newPatient.phone) {
				this.toast.error(this.userService.translateText('hospital_portal.disp_messages.mob_no_should_not_same.error'), '', {
					timeOut: this.timealert
				})
				return self.newPatient.phoneOther = ''
			} else {
				let code = self.newPatient.codeOther.split(',')
				let phone = code[0] + '-' + self.newPatient.phoneOther
				self.patientService.chenckPatientPhoneExists(phone, this.CurrentUser.item.userAccountKey)
					.subscribe(data => {
						if (data) {
							self.toast.error(this.userService.translateText('hospital_portal.disp_messages.mob_already_exists.error'), '', {
								timeOut: this.timealert
							})
							if (this.CurrentUser.item.clientTeleCode)
								self.newPatient.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
							else {
								if (this.CurrentUser.item.language != 'en_uk') {
									this.newPatient.codeOther = '+1,USA'
								} else if (this.CurrentUser.item.language == 'en_uk') {
									this.newPatient.codeOther = '+44,UK'
								}
							}
							self.newPatient.phoneOther = "";
							this.checkphonelength1(self.newPatient.codeOther)
						}
					})
			}
		}
	}


	rejectSpecialCharacters(stringValue: any, formControlName: string) {
		const specialCharsSet = new Set("[!@#$%^&*()_~+-=\\{};':|,.<>\/?]+/`");
		for (let letter of this.newPatient[formControlName]) {
			if (specialCharsSet.has(letter) || letter == '"') {
				this.newPatient[formControlName] = this.newPatient[formControlName].replaceAll(letter, '')
			}
		}
	}

	//check mrn number is already exists
	checkMrn(patientdetails, f) {
		let self = this;
		if (self.newPatient.mrn) {
			self.patientService.checkPatientMrnExist(self.newPatient.mrn, self.CurrentUser.item.userAccountKey)
				.subscribe(data => {
					if (data) {
						if (this.CurrentUser.item.language == 'en_uk')
							self.toast.error(this.userService.translateText('hospital_portal.disp_messages.nhs_already_registered.error'), '', {
								timeOut: this.timealert
							})
						else
							self.toast.error(this.userService.translateText('hospital_portal.disp_messages.mrn_already_registered.error'), '', {
								timeOut: this.timealert
							})
						self.newPatient.mrn = ""

					} else {
						let mrn = {
							"mrn": self.newPatient.mrn,
							"hospitalId": this.CurrentUser.item.userAccountKey
						}
						this.getPatientDetails(mrn, patientdetails, f)
					}
				})
		}

	}
	//check ssn already exists
	checkSsn() {
		let self = this;
		if (self.newPatient.ssn) {
			self.patientService.checkPatientSsnExists(self.newPatient.ssn)
				.subscribe(data => {
					if (data) {
						self.newPatient.ssn = ''
						self.toast.error(this.userService.translateText('hospital_portal.disp_messages.ssn_already_registered.error'), '', {
							timeOut: this.timealert
						})
					}
				})
		}
	}
	//check service is available with logged cc
	/**
	 *
	 * @param event service line value
	 * @param index index
	 */
	checkServiceAvailablity(bodypart, side, surgeonId, index) {
		////console.log(side, surgeonId, bodypart)
		this.sidepart = side;
		this.surgeonname = surgeonId
		let self = this;
		if (side && surgeonId && bodypart) {

			//let sArray = event.split('-')
			// self.getBodyParts(bodyLocation,index)
			self.patientService.getBodyPartServiceAvailable(bodypart, side, surgeonId)
				.subscribe(data => {
					if (data.surveyStatus == 'false') {
						self.listOfParts[index].bodyPart = ""
						self.listOfParts[index].other = ""
						self.listOfParts[index].bodySide = ""
						this.sidepart = ""
						self.toast.error(this.userService.translateText('hospital_portal.disp_messages.selected_service.error'), '', {
							timeOut: this.timealert
						})
					}
					if (data.surveyStatus == 'true') {
						self.listOfParts[index].workflowId = data.viewWorkflowId;
					}
					//  if()
				})
		} else if (bodypart == 'Lumbar Fusion' || bodypart == 'Lumbar Laminectomy' || bodypart == 'Cervical Fusion' || bodypart == 'Cervical Laminectomy' || bodypart == 'T-Spine' || (bodypart == 'Other.' && (this.listOfParts[index].bodyLocation == 'Back' || this.listOfParts[index].bodyLocation == 'Neck'))) {
			self.patientService.getBodyPartServiceAvailable(bodypart, this.partbody, surgeonId)
				.subscribe(data => {
					if (data.surveyStatus == 'false') {
						//self.listOfParts[index].bodyPart=""
						self.listOfParts[index].bodyPart = ""
						self.listOfParts[index].other = ""
						self.listOfParts[index].bodySide = ""
						self.toast.error(this.userService.translateText('hospital_portal.disp_messages.selected_service.error'), '', {
							timeOut: this.timealert
						})
					}
					if (data.surveyStatus == 'true') {
						self.listOfParts[index].workflowId = data.viewWorkflowId;
					}
					//  if()
				})
		}
	}
	//upload patient image
	/**
	 *
	 * @param event file upload event
	 */
	fileUpload(event) {
		let acceptFormat = ['image/png', 'image/x-png', 'image/jpeg', 'image/jpg']
		let reader = new FileReader();
		reader.readAsDataURL(event.target.files[0]);
		reader.onload = (events: any) => {
			if (!acceptFormat.includes(event.target.files[0].type)) {
				this.toast.error(this.userService.translateText('hospital_portal.disp_messages.file_not_allowed.error'), '', {
					timeOut: this.timealert
				})
				this.myInputVariable.nativeElement.value = "";
				this.patientUrl = this.defaultUl;
				return;
			}
			if (event.target.files[0].size > this.imgMaxSize) {
				this.toast.error(this.userService.translateText('patient_portal.validations.maximum_size_exceed.error_label'), '', {
					timeOut: this.timealert
				})
				this.myInputVariable.nativeElement.value = "";
				this.patientUrl = this.defaultUl;
				return;
			} else {
				this.patientUrl = events.currentTarget.result;
				this.imagearr = [{
					filename: event.target.files[0].name,
					filetype: event.target.files[0].type,
					value: events.currentTarget.result.split(',')[1]
				}];
			}

		}
	}
	//save patient details
	/**
	 *
	 * @param f formobject
	 * @param redirect option to redirect home or not
	 */
	savePatient(f: NgForm, selection1: TemplateRef<any>, redirect) {
		this.redir = redirect;
		this.showloader = true;
		this.open(selection1, f)
	}

	open(selection1: TemplateRef<any>, f) {
		let comercialtype;
		if (this.CurrentUser.item.commercialType) {
			comercialtype = 1
		} else {
			comercialtype = -1
		}
		if (f.value.email && comercialtype == -1) {
			this.patientService.getPatientDelEmailExist(f.value.email)
				.subscribe(data => {
					if (data.status == 'true') {
						this.userService.logAudit('getdeletedstatus', 0).subscribe(data => { })
						for (var i = 0; i < data.procedure.length; i++) {
							if (data.procedure[i].procedure != 'Other.')
								this.procedure = data.procedure[i].procedure
							else
								this.procedure = 'Other'
							this.dos = data.procedure[i].dos
						}
						this.procedurestr = this.procedure;
						this.dosstr = this.dos;
						this.showloader = false;
						this.modalRef1 = this.modalService.show(selection1, {
							class: 'modal-sm',
							backdrop: 'static'
						})
						this.movable()
					} else if (data.status == 'false') {
						let self = this;
						this.enablepatient = false;


						if (self.listOfParts.length == 0) {
							self.toast.error(this.userService.translateText('hospital_portal.add_patient.add_patient_body_part.error'), '', {
								timeOut: this.timealert
							});
							this.showloader = false;
							return;
						}

						let telecode = self.newPatient.code.split(',')

						const patientExist = {
							"email": self.newPatient.email,
							"hospitalId": this.CurrentUser.item.userAccountKey,
							"phone": self.newPatient.phone,
							"teleCode": telecode[0],
							"archiveMode" : "ARCHIVE-SAVE"
						}
						if((self.newPatient.email && this.isArchivedEmail == 'EXISTING_ARCHIVE') || (self.newPatient.phone && this.isArchivedPhone == 'EXISTING_ARCHIVE')) {
						self.patientService.insertArchivedPatientExist(patientExist)
							.subscribe(data2 => {
								if (data2?.status != "Success") {
									this.enablepatient = true;
									self.toast.error(this.userService.translateText('hospital_portal.add_patient.patient_already_exists.error'), '', {
										timeOut: this.timealert
									})
									this.showloader = false;
								} else {
									this.addPatientAPI(comercialtype, f)
								}

							})
						} else 
						this.addPatientAPI(comercialtype, f)

					}
					this.globalobj = f;

				})
		} else {
			let self = this;
			this.enablepatient = false;

			this.showloader = true;

			if (self.listOfParts.length == 0) {
				self.toast.error(this.userService.translateText('hospital_portal.add_patient.add_patient_body_part.error'), '', {
					timeOut: this.timealert
				});
				this.showloader = false;
				return;
			}
			//let dob = self.datepipe.transform(self.newPatient.dob, 'yyyy-MM-dd')


			let telecode = self.newPatient.code.split(',')

			const patientExist = {
				"email": self.newPatient.email,
				"hospitalId": this.CurrentUser.item.userAccountKey,
				"phone": self.newPatient.phone,
				"teleCode": telecode[0],
				"archiveMode" : "ARCHIVE-FETCH"
			}

			if((self.newPatient.email && this.isArchivedEmail == 'EXISTING_ARCHIVE') || (self.newPatient.phone && this.isArchivedPhone == 'EXISTING_ARCHIVE')) {
				self.patientService.insertArchivedPatientExist(patientExist)
				.subscribe(Userdata => {
				if (Userdata.status != "Success") {
					this.enablepatient = true;
					self.toast.error(this.userService.translateText('hospital_portal.add_patient.patient_already_exists.error'), '', {
						timeOut: this.timealert
					})
					this.showloader = false;
				} else {
					this.addPatientAPI(comercialtype, f)
				}
			})
			} else this.addPatientAPI(comercialtype, f)
		}
	}

	addPatientAPI(comercialtype, f) {
		
		this.arrangreData().then(

			data1 => {

				if (this.newPatient.phone) {
					if (this.newPatient.code == "") {
						this.toast.error(this.userService.translateText('hospital_portal.add_patient.please_select_country_code'), '', {
							timeOut: this.timealert
						});
						this.enablepatient = true;
						this.showloader = false;
					} else {
						this.addPatient(data1, comercialtype, f);
					}
				} else if (this.newPatient.phoneOther) {
					if (this.newPatient.codeOther == "") {
						this.toast.error(this.userService.translateText('hospital_portal.add_patient.please_select_country_code'), '', {
							timeOut: this.timealert
						});
						this.enablepatient = true;
						this.showloader = false;
					} else {
						this.addPatient(data1, comercialtype, f);
					}
				} else if (!this.newPatient.phone) {
					this.addPatient(data1, comercialtype, f);
				}
			} //data
		)
	}

	yestoshow1(data) {
		if (data) {
			this.newPatient.commercialPayorType = this.payorinfo.payorId
			this.newPatient.plan = this.payorinfo.plans
			this.newPatient.tss = this.payorinfo.TSS
			this.getbundlepayortype(this.payorinfo.payorId)
		} else {
			this.newPatient.commercialPayorType = ''
			this.newPatient.plan = ''
			this.newPatient.tss = ''
		}
		this.modalRef1.hide();
	}
	//before save the patient details rearrange the data in meaning full json

	yestoshow(data) {
		let comercialtype;
		if (this.CurrentUser.item.commercialType) {
			comercialtype = 1
		} else {
			comercialtype = -1
		}
		this.deletepa = data;
		////console.log(this.deletepa)
		let f = this.globalobj
		let self = this;
		this.enablepatient = false;
		this.showloader = true;
		if (self.listOfParts.length == 0) {
			self.toast.error(this.userService.translateText('hospital_portal.add_patient.add_patient_body_part.error'), '', {
				timeOut: this.timealert
			});
			this.showloader = false;
			return;
		}
		//let dob = self.datepipe.transform(self.newPatient.dob, 'yyyy-MM-dd')
		let telecode = self.newPatient.code.split(',')

		const patientExist = {
			"email": self.newPatient.email,
			"hospitalId": this.CurrentUser.item.userAccountKey,
			"phone": self.newPatient.phone,
		    "ARCHIVE-FETCH":self.newPatient.primary,
			"teleCode": telecode[0]
		}
		self.patientService.checkPatienExists(patientExist)
			.subscribe(data1 => {
				if(data1?.validate_pt == 'ADD_PATIENT_ERROR') {
					this.toast.error(this.userService.translateText('patient_portal.display_messages.something_went_wrong'))
				}
				else if (data1?.validate_pt != 'NEW_PATIENT') {
					this.enablepatient = true;
					self.toast.error(this.userService.translateText('hospital_portal.add_patient.patient_already_exists.error'), '', {
						timeOut: this.timealert
					})
					this.showloader = false;
				} else {

					self.arrangreData().then(

						data => {
							//console.log(data, "Add Pat data")
							if (self.newPatient.phone) {
								if (self.newPatient.code == "") {
									this.toast.error(this.userService.translateText('hospital_portal.add_patient.please_select_country_code'), '', {
										timeOut: this.timealert
									});
									this.enablepatient = true;
									this.showloader = false;
								} else {
									this.addPatient(data, comercialtype, f)

								}
							} else if (self.newPatient.phoneOther) {
								if (self.newPatient.codeOther == "") {
									this.toast.error(this.userService.translateText('hospital_portal.add_patient.please_select_country_code'), '', {
										timeOut: this.timealert
									});
									this.enablepatient = true;
									this.showloader = false;
								} else {
									this.addPatient(data, comercialtype, f)
								}
							} else if (!self.newPatient.phone) {
								this.addPatient(data, comercialtype, f)
							}
						} //data
					)

				}

			})
		this.modalRef1.hide();

	}


	arrangreData() {

		let self = this;
		////console.log("number", self.newPatient)
		if (this.deletepa) {
			self.newPatient.deletepatient = 'yes'
		} else {
			self.newPatient.deletepatient = 'no'
		}

		self.temPatien = Object.assign({}, self.newPatient)

		if (self.newPatient.dob) {
			self.temPatien.dob = self.datepipe.transform(self.temPatien.dob, 'yyyy-MM-dd');
		}
		if (!self.newPatient.commercialPayor) {
			self.temPatien.commercialPayor = 4
		}

		if (self.listOfParts[0].hospitalId) {
			self.temPatien.dropDownSOSId = self.listOfParts[0].hospitalId;
		}
		if (self.imagearr.length) {
			self.temPatien.uploadimage = self.imagearr;
		}
		if (self.newPatient.phone) {
			let telecode = self.newPatient.code.split(',')
			self.temPatien.teleCode = telecode[0]
			self.temPatien.teleCountryCode = telecode[1]
			self.temPatien.phone = self.newPatient.phone;
			////console.log("code", self.temPatien.phone)

		}
		if (self.newPatient.phoneOther) {
			let telecode = self.newPatient.codeOther.split(',')
			if (self.newPatient.otherPhoneType) {
				self.temPatien.otherPhoneType = self.newPatient.otherPhoneType
			}
			self.temPatien.teleCodeOther = telecode[0]
			self.temPatien.teleCountryCodeOther = telecode[1]
			self.temPatien.phoneOther = self.newPatient.phoneOther;
			////console.log("code", self.temPatien.phone)

		}
		if (self.newPatient.disqualifi && self.listOfParts[0].payorType == 1) {
			self.temPatien.disqualifi = self.newPatient.disqualifi
		}

		let promise = new Promise((resolve, reject) => {
			for (let i = 0; i < 3; i++) {
				if (self.listOfParts[i]) {
					let bodyPart = {
						carePath: '',
						other: '',
						bodyPartStatus: 'False',
						laterality: '',
						hospitalId: '',
						surgeonId: '',
						dos: '',
						mako: '',
						cjr: '',
						fracture: '',
						payorType: '',
						hic: '',
						dischargeDate: '',
						dischargeLoc: '',
						facilityPhone: '',
						facilityContact: '',
						dischargeWith: '',
						dischargeId: '',
						dischargeHospitalMasterId: '',
						dischargeTo: '',
						bpci: '',
					}
					if (self.listOfParts[i]) {
						bodyPart.bodyPartStatus = "True";
						if (self.listOfParts[i].hasOwnProperty('bodyPart')) {
							let data = self.listOfParts[i]['bodyPart'].split('###');
							bodyPart.carePath = `'${data[0]}'`;
							if (data[0] == 'Lumbar Fusion' || data[0] == 'Lumbar Laminectomy' || data[0] == 'Cervical Fusion' || data[0] == 'Cervical Laminectomy' || data[0] == 'T-Spine' || (data[0] == 'Other.' && (self.listOfParts[i].bodyLocation == 'Back' || self.listOfParts[i].bodyLocation == 'Neck'))) {
								bodyPart.laterality = `'${self.listOfParts[i]['bodyprocedure']}'`;
							} else
								bodyPart.laterality = `'${self.listOfParts[i]['bodySide']}'`;
							if (data[0] == 'Other' || data[0] == 'Other.') {
								bodyPart.other = self.listOfParts[i].other
							}
						}
						if (self.listOfParts[i].hasOwnProperty('hospitalId')) {
							bodyPart.hospitalId = self.listOfParts[i].hospitalId;
						}
						if (!bodyPart.hospitalId) {
							bodyPart.hospitalId = '100000';
							self.listOfParts[i].hospitalId = '100000'
							self.temPatien.dropDownSOSId = '100000';
						}
						if (self.listOfParts[i].hasOwnProperty('surgeonId') && self.listOfParts[i].surgeonId) {
							bodyPart.surgeonId = self.listOfParts[i].surgeonId;
						} else {
							bodyPart.surgeonId = '500000'
							self.listOfParts[i].surgeonId = '500000'
						}
						if (self.listOfParts[i].hasOwnProperty('dos')) {
							bodyPart.dos = self.datepipe.transform(self.listOfParts[i].dos, 'yyyy-MM-dd')
						} else {
							bodyPart.dos = ''
						}
						bodyPart.mako = self.listOfParts[i].mako;
						if (self.listOfParts[i].hasOwnProperty('cjr')) {
							if (self.listOfParts[i].cjr == "Yes" || self.listOfParts[i].cjr)
								bodyPart.cjr = 'Yes';
						}
						if (self.listOfParts[i].hasOwnProperty('fracture')) {
							if ((self.listOfParts[i].fracture || this.fracture) && self.listOfParts[i].bodyprocedure == 'Hip')
								bodyPart.fracture = 'Yes';
							else {
								let data = self.listOfParts[i]['bodyPart'].split('###');
								bodyPart.carePath = `'${data[0]}'`;
								if (data[0].toUpperCase() == 'HIP AND FEMUR FRACTURE (SHFFT)' || data[0].toUpperCase() == 'PARTIAL HIP REPLACEMENT') {
									bodyPart.fracture = 'Yes';
								}
							}
						}
						if (self.listOfParts[i].hasOwnProperty('payorType')) {
							//if(self.listOfParts[i].payorType == 2){
							bodyPart.bpci = self.getBpci()
							////console.log("save", bodyPart.bpci)
							//}
							bodyPart.payorType = self.listOfParts[i].payorType
							////console.log("save1", bodyPart.payorType)
						}
						if (self.listOfParts[i].hasOwnProperty('hic')) {
							bodyPart.hic = self.listOfParts[i].hic;
						}
						if (self.listOfParts[i].hasOwnProperty('dischargeDate')) {
							bodyPart.dischargeDate = self.datepipe.transform(self.listOfParts[i].dischargeDate, 'yyyy-MM-dd');
						}
						if (self.listOfParts[i].hasOwnProperty('dischargeLoc')) {
							bodyPart.dischargeLoc = self.listOfParts[i].dischargeLoc;
						}
						if (self.listOfParts[i].hasOwnProperty('facilityPhone')) {
							bodyPart.facilityPhone = self.listOfParts[i].facilityPhone;
						}
						if (self.listOfParts[i].hasOwnProperty('facilityContact')) {
							bodyPart.facilityContact = self.listOfParts[i].facilityContact;
						}
						if (self.listOfParts[i].hasOwnProperty('dischargeUserName')) {
							bodyPart.dischargeWith = self.listOfParts[i].dischargeUserName;
						}
						if (self.listOfParts[i].hasOwnProperty('dischargeTo')) {
							if (self.listOfParts[i].dischargeTo != "") {
								let index = _.findIndex(self.snfList, (o: any): any => {
									return o.dischargeHospitalMasterId == self.listOfParts[i].dischargeTo
								})
								bodyPart.dischargeTo = self.snfList[index].dischargeTo;
								bodyPart.dischargeId = self.snfList[index].dischargeId;
								bodyPart.dischargeHospitalMasterId = self.snfList[index].dischargeHospitalMasterId;
							}
						}

					}
					self.temPatien.AddBodyPart[i] = bodyPart;

				} else {
					self.temPatien.AddBodyPart[i] = self.defaultBodyPart;
				}
			}
			if (self.imagearr.length) {
				if (self.temPatien.uploadimage.length) {
					resolve(self.temPatien)
				}
			} else {
				resolve(self.temPatien)
			}

		});

		return promise;
	}
	//get user id of the discharge with option
	formdischaregeChange(event, form) {
		let self = this;
		if (event == 'Choose') {
			if (form == 'main') {
				if (self.bodyPartDetails.dischargeUserName) {
					delete self.bodyPartDetails.dischargeUserName
				}
			}
			if (form != 'main') {
				if (self.listOfParts[form].dischargeUserName) {
					delete self.listOfParts[form].dischargeUserName
				}
			}
		}
		if (event != 'Choose') {
			// if(form == 'main'){
			self.getsurgeonUserName(event, form)
			// }
			// if(form != 'main'){
			//   self.listOfParts[form].dischargeUserName = self.getsurgeonUserName(event,)
			// }
		}
	}
	//set the user name for selected surgeon
	/**
	 *
	 * @param id user id of surgeon
	 * @param form index
	 */
	getsurgeonUserName(id, form) {
		let self = this;
		self.patientService.getSurgeonUserId(id)
			.subscribe(data => {
				if (form == 'main') {
					self.bodyPartDetails.dischargeUserName = data.surUserAccId;
				}
				if (form != 'main') {
					self.listOfParts[form].dischargeUserName = data.surUserAccId;
				}
				return;
			})
	}
	//calculate the bpci
	/* getBpci(){
		let self = this;
		let diff_ms = Date.now() - self.newPatient.dob.getTime();
		let age_dt = new Date(diff_ms);

		let age = Math.abs(age_dt.getUTCFullYear() - 1970);
		if(age >= 65){
			return 'Yes';
		}
		if(age < 65){
			return 'No'
		}
	}
	 */
	getBpci() {

		if (this.medicare == 2 && this.clienttype && this.clienttype.search("BPCIA") != -1 && this.listOfParts[0].bodyPart != 'Revision Knee Replacement' && this.listOfParts[0].bodyPart != 'Revision Hip Replacement' && !this.listOfParts[0].cjr) {
			return 'Yes';
		} else {
			return 'No'
		}

	}

	//get view worrflow episodes
	/**
	 *
	 * @param template view workflow template
	 * @param workflow workflowId
	 */
	openViewModal(template: TemplateRef<any>, workflowId: any) {
		let self = this;
		self.patientService.getWorkflowStages(workflowId)
			.subscribe(data => {
				self.stageArray = data
				if (data.length) {
					self.getStageDetails(data[0]['episodeId'])
				}
				this.modalRef = this.modalService.show(template, Object.assign({}, {
					class: 'materialtab gray modal-lg',
				}));
				this.movable()
				// this.viewWorkflow= workflow
			})

	}
	//get stage Material Details array
	/**
	 *
	 * @param id episode Id
	 */
	getStageDetails(id) {
		let self = this;
		self.tabID = id;
		self.showTable = false
		self.patientService.getStagesMaterials(id)
			.subscribe(data => {
				self.materialsArray = _.orderBy(data, ['elapsedTime'], ['desc']);
				self.showTable = true
			},
				err => {
					self.showTable = true;
				}
			)
	}


	//clear body part value
	/**
	 *
	 * @param i index
	 */
	clearBodyPart(i) {
		let self = this;
		self.listOfParts[i].bodyPart = ''
		self.listOfParts[i].other = ''
		self.listOfParts[i].bodySide = ''
	}
	dateValueChange(event) {
		if (event.keyCode != 8) {
			if (event.target.value.length == 2 || event.target.value.length == 5) {
				var thisVal = event.target.value;
				thisVal += '/';
				event.target.value = thisVal;
			}
		}
	}
	checkfrac(bodyPart, i) {
		if (bodyPart.toUpperCase() == 'HIP AND FEMUR FRACTURE (SHFFT)' || (bodyPart.toUpperCase()) == 'PARTIAL HIP REPLACEMENT') {
			this.listOfParts[i].fracture = true
			return true
		} else {
			this.listOfParts[i].fracture = false
			return false
		}
	}
	checfrac(event, i) {
		this.listOfParts[i].fracture = event.target.checked
		this.fracture = event.target.checked
	}
	checkempty(id) {
		////console.log(id, this.dosMaxDate)
		var d = new Date(id);
		var timeDiff = Math.ceil(d.getTime() - this.dosMaxDate.getTime());
		var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
		////console.log(diffDays)
		if (id == '' || id == null || id == 'Invalid Date') {
			this.showinvaild = true
		} else if (id != '' && id != null) {
			this.showinvaild = false
		}
		if (diffDays > 0) {

			this.listOfParts[0].dos = '';
			this.toast.error(this.userService.translateText('hospital_portal.disp_messages.invalid_date.error'), '', {
				timeOut: this.timealert
			})
			return;

		}

	}

	checkempty1(id) {
		let date
		this.listOfParts[0].dos = ''
		if (id != 'Invalid Date')
			date = this.datepipe.transform(id, 'yyyy-MM-dd');
		let curentdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
		if (id == '' || id == null || id == 'Invalid Date') {
			this.newPatient.dob = null
			this.showinvaild1 = true;
			this.mindate = false;
			this.maxdate = false;
		} else if (id != '' && id != null && date <= "1800-01-01") {
			this.newPatient.dob = null
			this.mindate = true;
			this.showinvaild1 = false;
			this.maxdate = false;
		} else if (id != '' && id != null && date > curentdate) {
			this.newPatient.dob = null
			this.maxdate = true;
			this.showinvaild1 = false;
			this.mindate = false;
		} else {
			this.showinvaild1 = false;
			this.mindate = false;
			this.maxdate = false;
			this.mindatedob = id;
		}

	}

	check(id) {
		////console.log(id)
		if (id == '' || id == null) {
			this.shospital = true
			////console.log("true")
		} else if (id != '' && id != null) {
			this.shospital = false
			////console.log("false")
		}

	}
	check1(id) {
		////console.log(id)
		if (id == '' || id == null) {
			this.shospital1 = true
			////console.log("true")
		} else if (id != '' && id != null) {
			this.shospital1 = false
			////console.log("false")
		}

	}
	check2(id) {
		////console.log(id)
		if (id == '' || id == null) {
			this.shospital2 = true
			////console.log("true")
		} else if (id != '' && id != null) {
			this.shospital2 = false
			////console.log("false")
		}

	}
	check3(id) {
		////console.log(id)
		if (id == '' || id == null) {
			this.shospital3 = true
			////console.log("true")
		} else if (id != '' && id != null) {
			this.shospital3 = false
			////console.log("false")
		}

	}
	check5(id) {
		////console.log(id)
		if (id == '' || id == null) {
			this.shospital5 = true
			////console.log("true")
		} else if (id != '' && id != null) {
			this.shospital5 = false
			////console.log("false")
		}

	}
	check6(id) {
		////console.log(id)
		if (id == '' || id == null) {
			this.shospital6 = true
			////console.log("true")
		} else if (id != '' && id != null) {
			this.shospital6 = false
			////console.log("false")
		}

	}
	check7(id) {
		////console.log(id)
		if (id == '' || id == null) {
			this.shospital7 = true
			////console.log("true")
		} else if (id != '' && id != null) {
			this.shospital7 = false
			////console.log("false")
		}

	}
	checked(value) {
		this.hiddenchecked = true;
		if (value) {
			this.showcross = true;
		}

	}

	backFromAddPatient() {

		/**** Patient Enroller User (If click back button go to patientlist - Default Navigation is MyTO)****/
		if (this.CurrentUser.item.userGroupId == 30 || this.CurrentUser.item.userGroupId == 31)
			this.router.navigate(["/care/patientlist/"]);
		else
			this.router.navigate(["/care/mytodo/"]);
		/** Default Back Navigation is go to MyTODO*/
	}


	checkphonelength(e) {
		this.newPatient.phone = "";
		let telecode = e.split(',')
		let codecoun = telecode[1]
		this.userService.phonebycountrycode(codecoun)
			.subscribe(
				data => {
					this.setlength = data.Length;
					this.maxlen = data.Length + this.CurrentUser.item.length;
					if (data.Length == 11) {
						this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0')
					} else {
						this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0')
					}
				}
			);
	}
	checkphonelength1(e) {
		this.newPatient.phoneOther = "";
		let telecode = e.split(',')
		let codecoun = telecode[1]
		this.userService.phonebycountrycode(codecoun)
			.subscribe(
				data => {
					this.setlength1 = data.Length;
					this.maxlen1 = data.Length + this.CurrentUser.item.length;
					if (data.Length == 11) {
						this.setmask1 = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0')
					} else {
						this.setmask1 = this.CurrentUser.item.phoneFormat.split('#').join('0')
					}
				}
			);
	}
	movable() {
		$(function () {
			let modalContent: any = $('.modal-content');
			let modalHeader = $('.modal-header');
			modalHeader.addClass('cursor-all-scroll');
			modalContent.draggable({
				handle: '.modal-header'
			});
		});
	}



	//Other SOS Popup
	patdisqualifi: any = {}
	reason: any;
	otherHospId: any = 0;
	othersos(hospitalId, sostemplate) {
		this.patdisqualifi = {}
		this.otherHospId = _.filter(this.hospitalList, (n) => {
			return (n.name.match('Other'))
		})
		this.otherHospId = this.otherHospId.map(function (el) { return el.hospitalId; });
		if (hospitalId == this.otherHospId) {
			this.reasonstage()
			this.patdisqualifi.reasonId = ''
			this.modalRef = this.modalService.show(sostemplate, { class: 'modal-lg', backdrop: "static" });
			this.movable()
		}
	}
	reasonstage() {
		this.patientService
			.getReasonCodeDetailsList()
			.subscribe(
				data => {
					this.reason = data;
				}

			);
	}
	close() {
		this.listOfParts[0].hospitalId = ''
		this.modalRef.hide();
	}
	disqualifipatient(data) {
		if (data) {
			if (this.patdisqualifi) {
				let disqualifi = {
					othersos: this.patdisqualifi.sos,
					notes: this.patdisqualifi.notes ? this.patdisqualifi.notes : '',
					reasonId: this.patdisqualifi.reasonId,
					other: this.patdisqualifi.other ? this.patdisqualifi.other : ''
				}
				this.newPatient.disqualifi = disqualifi
				this.modalRef.hide();
			}
		}
	}


	//Alternate Phone Number
	otherPhone: any = false
	viewalterno(otherPhone) {
		if (!otherPhone) {
			this.otherPhone = true
			this.newPatient.otherPhoneType = 1
			this.changeAlterNo()
		}
	}

	changeAlterNo() {
		if (this.CurrentUser.item.language != 'en_uk') {
			this.newPatient.codeOther = '+1,USA'
		} else if (this.CurrentUser.item.language == 'en_uk') {
			this.newPatient.codeOther = '+44,UK'
		}
		if (this.CurrentUser.item.clientTeleCode) {
			this.newPatient.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
		}
		this.newPatient.phoneOther = ''
	}



	//Deactive Patient Histroy
	getPatientDetails(patdetails, patientdetails, f) {
		let self = this
		this.globalobj = f
		self.patientService.getDeactivePatientExist(patdetails, self.CurrentUser.item.userAccountKey)
			.subscribe(data => {
				////console.log(this.timealert)
				if (!data.patientType && data.AddBodyPart) {
					self.patientinfo = data
					this.modalRef1 = this.modalService.show(patientdetails, {
						class: 'modal-md',
						backdrop: 'static'
					})

					if (this.patientinfo.AddBodyPart && this.patientinfo.AddBodyPart[0].pswIsActive) {
						self.newPatient.email = "";
						self.newPatient.phone = "";
					}
				} else {
					return false;
				}
			})
		return true;
	}

	existingPatSWFId: any;
	imageURL: any;
	yesToShowPat(status) {
		if (status) {
			this.modalRef1.hide();
			let payorType = this.patientinfo.AddBodyPart[0].payorType;
			this.formPayorTypeChange('', payorType);
			//this.getbundlepayortype(payorType);

			// this.listOfParts[0].bodyLocation = '';
			// this.listOfParts[0].bodyPart = ''
			// this.listOfParts[0].bodySide = ''
			this.newPatient = this.patientinfo;
			this.newPatient.dob = new Date(this.patientinfo.dob);
			if (this.newPatient.uploadimage && this.newPatient.uploadimage.search("default_") == -1) {
				if (this.CurrentUser.item) {
					if (this.CurrentUser.item.hostModel == "CLOUD")
						this.imageURL = environment.cloudeImageURL;
					else
						this.imageURL = environment.vmImageURL;
				}
				this.patientUrl = this.imageURL + this.newPatient.uploadimage;
			}
			this.existingPatSWFId = this.patientinfo.patientSwfId;
			this.listOfParts[0] = this.newPatient.AddBodyPart[0]
			this.listOfParts[0].bodyLocation = this.newPatient.AddBodyPart[0].bodyLocation;
			this.listOfParts[0].dos = this.newPatient.AddBodyPart[0].dos ?
				new Date(this.newPatient.AddBodyPart[0].dos) : this.newPatient.AddBodyPart[0].dos;
			this.newPatient.code = this.newPatient.teleCode ?
				this.newPatient.teleCode + ',' + this.newPatient.teleCountryCode : '+1,USA';
			this.newPatient.otherPhoneType = 1;
			this.newPatient.preferredLanguage = this.userService.cnDefaultLang;
			this.newPatient.codeOther = this.newPatient.teleCodeOther
				? this.newPatient.teleCodeOther + ',' + this.newPatient.teleCountryCodeOther : '+1,USA';
			if (this.patientinfo.AddBodyPart[0].bodySide == "Back" || this.patientinfo.AddBodyPart[0].bodySide == "Neck") {
				this.show = false;
			}
			//this.listOfParts[0].payorType = 2;
			//setTimeout(() => {
			// this.listOfParts[0] = this.newPatient.AddBodyPart[0];
			// this.listOfParts[0].dos = this.newPatient.AddBodyPart[0].dos ?
			// 			 new Date(this.newPatient.AddBodyPart[0].dos) : this.newPatient.AddBodyPart[0].dos;
			// this.newPatient.dischargeDate = this.newPatient.AddBodyPart[0].dischargeDate ?
			// new Date(this.newPatient.AddBodyPart[0].dischargeDate) : this.newPatient.AddBodyPart[0].dischargeDate;

			//},10);

			console.log("this.newPatient", this.newPatient)

		} else {
			this.newPatient.email = ''
			this.newPatient.phone = ''
			this.modalRef1.hide();
		}
	}

	getClientType() {
		if (this.clienttype && (this.clienttype.search("CJR") != -1 || this.clienttype.search("PRO_ONLY") != -1))
			return 'CJR'
		else if (this.clienttype && (this.clienttype.search("MAKO") != -1 || this.clienttype.search("NON_GROUP") != -1))
			return 'MAKO'
		else
			return false
	}

	addPatient(data1, comercialtype, f) {
		let self = this;
		self.patientService.addNewPatient(data1, this.CurrentUser.item.userAccountId, comercialtype, this.newPatient.skipcommercial)
			.subscribe(data => {
				if (data) {
					self.toast.success(this.userService.translateText('hospital_portal.add_patient.patient_saved.success'), '', {
						timeOut: this.timealert
					});
					this.userService.logAudit('addNewPatient', 0).subscribe(data => { })

					this.enablepatient = true;
					this.ngOnInit()
					this.showloader = false;
					this.patientService
						.getmytodolist(this.CurrentUser.item.userAccountId)
						.subscribe(
							data => {
								//this.temp_var=true;
								this.mytodo = data;
								this.CurrentUser.item.mytodolength = this.mytodo.length
							}
						);
					this.patientService.getcountqual('Default', this.CurrentUser.item.userAccountId, this.CurrentUser.item.selectCNUserId).subscribe(
						data => {
							if (data)
								this.CurrentUser.item.pqtlength = parseInt(data.Count)
						}
					)

					if (this.redir && !this.newPatient.skipcommercial && this.newPatient.AddBodyPart[0].payorType == 1 && this.CurrentUser.item.commercialType && this.CurrentUser.item.userrole == 'Commercial Care Navigator') {
						f.resetForm();
						self.router.navigate(['/care/patientqualification'],)
						this.showloader = false;

					} else if (this.redir && (this.CurrentUser.item.userGroupId == 30 || this.CurrentUser.item.userGroupId == 31 || this.CurrentUser.item.userrole == 'Commercial Care Navigator')) {
						f.resetForm();
						self.router.navigate(['/care/patientlist'],)
						this.showloader = false;

					} else if (this.redir && this.CurrentUser.item.userGroupId != 34) {
						f.resetForm();
						self.router.navigate(['/care/mytodo'],)
						this.showloader = false;
					} else {
						if (this.router.url == '/care/addpatient')
							this.router.navigateByUrl('/care/addpatientnew');
						else
							this.router.navigateByUrl('/care/addpatient');
						f.resetForm();
						this.showloader = false;
					}
					if (!this.redir) {
						self.router.navigate(['/care/addnewpatient'])
						this.showloader = false;
					}
				} //data
				if (!data) {
					self.toast.error(this.userService.translateText('hospital_portal.disp_messages.patient_not_saved.error'), '', {
						timeOut: this.timealert
					})
					this.ngOnInit();
					this.showloader = false;
				}
			})
	}

	getSide(side) {
		if(side == 'Left') {
		  return this.userService.translateText('hospital_portal.body_part.left.label')
		} else if(side == 'Right') {
		  return this.userService.translateText('hospital_portal.body_part.right.label')
		} else if(side == 'Bilateral') {
		  return this.userService.translateText('hospital_portal.body_part.bilateral.label')
		}
	}
}
